export const GET_GROUP_LIST_SUCCESS = 'GET_GROUP_LIST_SUCCESS';
export const getGroupListSuccess = groups => ({
  type: GET_GROUP_LIST_SUCCESS,
  payload: {
    groups,
  },
});

export const GET_GROUP_LIST_ERROR = 'GET_GROUP_LIST_ERROR';
export const getGroupListError = error => ({
  type: GET_GROUP_LIST_ERROR,
  payload: {
    error,
  },
});

export const GET_GROUP_DEVICE_DATA_SUCCESS = 'GET_GROUP_DEVICE_DATA_SUCCESS';
export const getGroupDeviceDataSuccess = (groupId, groupItem) => ({
  type: GET_GROUP_DEVICE_DATA_SUCCESS,
  payload: {
    groupId,
    groupItem,
  },
});

export const GET_GROUP_ITEM_ERROR = 'GET_GROUP_ITEM_ERROR';
export const getGroupItemError = error => ({
  type: GET_GROUP_ITEM_ERROR,
  payload: {
    error,
  },
});

export const UPDATE_SELECTED_TAB = 'UPDATE_SELECTED_TAB';
export const updateSelectedTab = activeKey => ({
  type: UPDATE_SELECTED_TAB,
  payload: {
    activeKey,
  },
});

export const UPDATE_GROUP_LIST_STORE = 'UPDATE_GROUP_LIST_STORE';
export const updateGroupListStore = config => ({
  type: UPDATE_GROUP_LIST_STORE,
  payload: {
    config,
  },
});

export const TOGGLE_GROUP_LIST_LOADING = 'TOGGLE_GROUP_LIST_LOADING';
export const toggleGroupListLoading = isLoading => ({
  type: TOGGLE_GROUP_LIST_LOADING,
  payload: { isLoading },
});

export const UPDATE_FAMILY_ITEM_SUCCESS = 'UPDATE_FAMILY_ITEM_SUCCESS';
export const updateFamilyItemSuccess = response => ({
  type: UPDATE_FAMILY_ITEM_SUCCESS,
  payload: {
    response,
  },
});

export const TOGGLE_GROUP_LIST_REFRESHING = 'TOGGLE_GROUP_LIST_REFRESHING';
export const toggleGroupListRefreshing = groupRefreshing => ({
  type: TOGGLE_GROUP_LIST_REFRESHING,
  payload: { groupRefreshing },
});

export const TOGGLE_TAB_CHANGE_REFRESHING = 'TOGGLE_TAB_CHANGE_REFRESHING';
export const toggleTabChangeRefreshing = tabChangeRefresh => ({
  type: TOGGLE_TAB_CHANGE_REFRESHING,
  payload: { tabChangeRefresh },
});
